import { PropTypes } from 'prop-types'
import { useParams } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Calendar } from 'primereact/calendar'
import moment from 'moment/moment'
import Spinner from '../loader/Spinner'
import { Column } from 'primereact/column'
import { currencyFormatter } from '../../utils/CurrencyFormatter'
import { DataTable } from 'primereact/datatable'
import Button from '../formElements/Button'
import { InputNumber } from 'primereact/inputnumber'
import Icons from '../../assets/icons'
import { Dialog } from 'primereact/dialog'
import { FaRegStickyNote } from 'react-icons/fa'
import { currencyTypes } from '../../utils/Constants'
import { Dropdown } from 'primereact/dropdown'

const AddOutsourceInvoiceModalContent = ({ handleClose, handleAdd, invoiceId }) => {
	const { projectId } = useParams()
	const [request, loading] = useRequest()
	const { showToast } = useToast()
	const [addForm, setAddForm] = useState({
		projectId: projectId,
		invoiceName: null,
		invoiceDate: null,
		estimatedDate: null,
		amount: null,
		currency: null,
		items: [],
	})
	const [warning, setWarning] = useState(null)
	const [invoiceDate, setInvoiceDate] = useState(null)
	const [noteModal, setNoteModal] = useState({
		open: false,
		name: null,
		data: [],
	})

	useEffect(() => {
		getOutsourceInvoiceItems()
	}, [invoiceId])

	const getOutsourceInvoiceForCreate = () => {
		if (invoiceId || !invoiceDate) return

		request(`/Outsource/GetOutsourceInvoice`, {
			params: {
				projectId: projectId,
				invoiceDate: invoiceDate,
			},
		}).then((res) => {
			if (res.data.ok) {
				setAddForm(res.data.result)
				setWarning(res.data.metadata?.message)
			} else {
				showToast(res.data.metadata.message, 'error')
			}
		})
	}

	const getOutsourceInvoiceItems = () => {
		if (!invoiceId) return

		request(`/Outsource/GetOutsourceInvoiceItems`, { params: { invoiceId: invoiceId } }).then((res) => {
			if (res.data.ok) {
				setAddForm((prev) => ({ ...prev, items: res.data.result }))
			} else {
				showToast(res.data.metadata.message, 'error')
			}
		})
	}

	const handleChange = (e, name) => {
		if (name) {
			setAddForm((prev) => ({ ...prev, [name]: e }))
		} else {
			setAddForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
		}
	}

	const handleDetuctedDaysChange = (rowData, value) => {
		let total = 0
		const items = addForm.items.map((item) => {
			if (item.outsourceId === rowData.outsourceId) {
				item = {
					...item,
					deductedDays: value,
					amount: item.rate * (item.days - value),
				}
			}
			total += item.amount
			return item
		})
		let hasDifferentCurrency = addForm.items.some((item) => item.currency !== rowData.currency)
		setAddForm((prev) => ({ ...prev, items, amount: !hasDifferentCurrency ? total : prev.amount }))
	}

	const handleSubmit = () => {
		if (!addForm.invoiceName) {
			showToast('Lütfen adım girin', 'error')
		} else if (!addForm.invoiceDate) {
			showToast('Lütfen fatura tarihini girin', 'error')
		} else if (!(addForm.amount > 0)) {
			showToast('Lütfen fatura tutarını girin', 'error')
		} else if (!addForm.items.length) {
			showToast('En az bir personel ekli olmalıdır', 'error')
		} else if (!addForm.currency) {
			showToast('Lütfen fatura tutarının para birimini seçin', 'error')
		} else {
			request('/Outsource/CreateOutsourceInvoice', {
				method: 'POST',
				data: addForm,
			}).then((res) => {
				if (res.data.ok) {
					showToast('Fatura oluşturuldu', 'success')
					handleClose()
					handleAdd()
				} else {
					showToast(res.data.metadata.message, 'error')
				}
			})
		}
	}

	return (
		<>
			<div className='w-100 approval-modal-content' style={{ position: 'relative' }}>
				{loading && (
					<div
						className='d-flex w-100 h-100 justify-content-center align-items-center'
						style={{
							position: 'absolute',
							zIndex: 9999,
							background: 'rgba(255,255,255,0.8)',
						}}
					>
						<Spinner size={3} />
					</div>
				)}
				{!invoiceId && (
					<>
						<div className='d-flex align-items-center flex-wrap gap-3'>
							<div className='form-control flex-md-grow-0' style={{ width: '15rem', flexGrow: 1 }}>
								<Calendar
									view='month'
									dateFormat='mm/yy'
									placeholder='Dönem Seçiniz'
									value={invoiceDate && moment(invoiceDate).locale('en')._d}
									name='invoiceDate'
									onChange={(e) => {
										setInvoiceDate(moment(e.target.value).add(3, 'hours').toISOString())
									}}
								/>
							</div>
							<Button
								className='btn-primary'
								title='Hesapla'
								disabled={!invoiceDate}
								icon={<Icons.report2 />}
								handleClick={getOutsourceInvoiceForCreate}
							/>
						</div>
						<hr className='divider my-md-3' />
					</>
				)}

				{warning && <p className={'text-danger mb-1 text-small'}>* {warning}</p>}
				<DataTable
					emptyMessage={
						!invoiceId && !addForm.invoiceDate ? 'Lütfen faturasını kesmek istediğiniz ayı seçiniz' : 'Kayıt Bulunamadı'
					}
					loading={loading}
					responsiveLayout='stack'
					value={addForm.items}
					editMode='row'
					dataKey='id'
				>
					<Column
						headerClassName='text-bold bg-primary text-default'
						className='text-semi-bold text-sm'
						style={{ width: '1rem' }}
						body={(rowData) => {
							if (!rowData.notes?.length) return

							return (
								<FaRegStickyNote
									style={{ marginBottom: '-4px' }}
									title={'Notları Görüntüle'}
									onClick={() => {
										setNoteModal({ open: true, name: rowData.name, data: rowData.notes })
									}}
									size={20}
									className='text-default cursor-pointer'
								/>
							)
						}}
					/>
					<Column
						headerClassName='text-bold bg-primary text-default'
						className='text-semi-bold text-sm'
						field='name'
						style={{ width: 'auto' }}
						header='Personel Adı'
						sortable='true'
					/>
					<Column
						headerClassName='text-bold bg-primary text-default'
						className='text-semi-bold text-sm'
						field='position'
						style={{ width: 'auto' }}
						header='Pozisyon'
						sortable='true'
					/>
					<Column
						className='text-semi-bold text-sm'
						headerClassName='text-bold bg-primary text-default'
						field='days'
						header='Hesaplanan Gün'
						sortable='true'
						style={{ width: '10rem' }}
						body={(rowData) => {
							return <span>{rowData.isMonthlyPeriod ? '' : rowData.days}</span>
						}}
					/>
					{!invoiceId && (
						<Column
							className='text-semi-bold text-sm'
							headerClassName='text-bold bg-primary text-default'
							field='deductedDays'
							header='Çıkartılacak Gün'
							style={{ width: '8rem' }}
							body={(rowData) => {
								if (rowData.isMonthlyPeriod) return

								return (
									<input
										type='number'
										className='default-input small-input'
										max={rowData.days}
										value={rowData.deductedDays || 0}
										onChange={(e) => {
											const value = e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1')
											handleDetuctedDaysChange(rowData, value)
										}}
									/>
								)
							}}
						/>
					)}
					<Column
						className='text-semi-bold text-sm'
						headerClassName='text-bold bg-primary text-default'
						field='rate'
						header='Rate'
						sortable='true'
						style={{ width: '8rem' }}
						body={(rowData) => {
							return (
								<span>
									{currencyFormatter(rowData.rate)} {rowData.currency}
								</span>
							)
						}}
						footer={
							!invoiceId && addForm.items.length > 0 && (() => <span className={'text-bold text-right'}>Toplam: </span>)
						}
					/>
					<Column
						className='text-semi-bold text-sm'
						headerClassName='text-bold bg-primary text-default'
						field='amount'
						header='Fatura Tutarı'
						sortable='true'
						style={{ width: '12rem' }}
						body={(rowData) => {
							return (
								<span>
									{currencyFormatter(rowData.amount)} {rowData.currency}
								</span>
							)
						}}
						footer={
							!invoiceId &&
							addForm.items.length > 0 &&
							(() => (
								<div className='p-inputgroup'>
									<InputNumber
										mode='decimal'
										maxFractionDigits={2}
										minFractionDigits={2}
										placeholder='Tutar'
										name='amount'
										className={'flex-fill w-100'}
										value={addForm.amount && addForm.amount}
										onChange={(e) => handleChange(e.value, 'amount')}
									/>
									<Dropdown
										inputId='dropdown'
										options={currencyTypes}
										optionLabel='label'
										optionValue='value'
										dropdownIcon=''
										className={'flex-wrap w-auto'}
										value={addForm.currency}
										onChange={(e) => handleChange(e.value, 'currency')}
									/>
								</div>
							))
						}
					/>
				</DataTable>
				{!invoiceId && addForm.items.length > 0 && (
					<div className='row align-items-center justify-content-end flex-wrap mt-3 gap-3'>
						<div className='form-control flex-md-grow-0' style={{ width: '16rem', flexGrow: 1 }}>
							<input
								placeholder='Adım'
								className='default-input'
								type='text'
								name='name'
								value={addForm.invoiceName}
								onChange={(e) => handleChange(e)}
							/>
						</div>
						<div className='form-control flex-md-grow-0' style={{ width: '10rem', flexGrow: 1 }}>
							<Calendar
								view='month'
								dateFormat='mm/yy'
								placeholder='Kesilecek Ay'
								value={addForm.estimatedDate && moment(addForm.estimatedDate).locale('en')._d}
								name='estimatedDate'
								onChange={(e) => handleChange(moment(e.target.value).add(3, 'hours').toISOString(), 'estimatedDate')}
							/>
						</div>
						<Button
							className='btn-success'
							disabled={loading}
							title='Oluştur'
							handleClick={handleSubmit}
							icon={<Icons.check />}
						/>
					</div>
				)}
			</div>

			<Dialog
				style={{ width: '900px' }}
				header={noteModal.name + ' Not Listesi'}
				visible={noteModal.open}
				onHide={() => setNoteModal((prev) => ({ ...prev, open: false }))}
				draggable={false}
			>
				<div className='card'>
					<DataTable
						emptyMessage='Hiç Kayıt Bulunamadı'
						responsiveLayout='stack'
						value={noteModal.data}
						editMode='row'
						dataKey='id'
					>
						<Column
							className='text-semi-bold text-sm'
							headerClassName='text-bold bg-primary text-default'
							field='createdAt'
							header='Tarih'
							style={{ width: '10rem' }}
							dataType='date'
							sortable='true'
							body={(rowData) => {
								const date = rowData.updatedAt
									? moment(rowData.updatedAt).format('LL')
									: moment(rowData.createdAt).format('LL')
								return <span>{date}</span>
							}}
						/>
						<Column
							className='text-semi-bold text-sm'
							headerClassName='text-bold bg-primary text-default'
							field='createdBy'
							header='Kişi'
							sortable='true'
							style={{ width: '12rem' }}
							body={(rowData) => {
								const user = rowData.updatedBy || rowData.createdBy
								return <span>{user}</span>
							}}
						/>
						<Column
							className='text-semi-bold text-sm'
							headerClassName='text-bold bg-primary text-default'
							field='note'
							header='Not'
							style={{ width: 'auto', maxWidth: '300px' }}
							body={(rowData) => {
								return <span>{rowData.note}</span>
							}}
						/>
					</DataTable>
				</div>
			</Dialog>
		</>
	)
}

AddOutsourceInvoiceModalContent.propTypes = {
	handleClose: PropTypes.func,
	handleAdd: PropTypes.func,
	invoiceId: PropTypes.number,
}

export default AddOutsourceInvoiceModalContent
